<script>
    import Cookies from 'js-cookie';

    import {check_accordion_active} from '$lib/utils.js';
    import {query, categories, add_dossier_open, current_dossier_id} from '$lib/store.js';

    import plus_icon from './plus.svg';

    export let display = 'd-block';

    const toggle_add_dossier = () => ($add_dossier_open = !$add_dossier_open);
</script>

{#if $query && !$current_dossier_id}
    {#if Cookies.get('authenticatedAccount')}
        <button type="button" on:click|preventDefault={(event) => {event.stopPropagation(); check_accordion_active($categories); toggle_add_dossier();}} class="{display} btn btn-medium text-white float-end">
        Maak een dossier aan <img class="plus-icon" src="{plus_icon}" alt="" width="16" height="16">
    </button>
    {:else}
        <button type="button" data-bs-toggle="modal" data-bs-target="#call-to-action" class="{display} btn btn-medium text-white float-end">
            Maak een dossier aan <img class="plus-icon" src="{plus_icon}" alt="" width="16" height="16">
        </button>
    {/if}
{/if}

<style lang="scss">
    button {
        margin: var(--margin);
        padding: 8px 14px 8.5px 22px;
        height: 40px;
        background-color: var(--dark-blue-color);
        border-radius: 100px;
        border-width: 0;
        box-shadow: none;
        font-weight: bold;
        line-height: 22px;

        &:hover {
            background-color: var(--dark-blue-color);
        }

        img {
            position: relative;
            top: -2px;
            margin-left: 8px;
            width: 16px;
        }
    }
</style>
